export const FABRIC_CONVERSATION_SHORTCUT = "ctrl+shift+a";
export const FABRIC_CONVERSATION_HINT = "ctrl+shift+a chat";
